export default __webpack_public_path__ + "static/media/oneid-large-uk-passport.d31c4d8a.jpg";